import AtendimentoService from './../_services/AtendimentoService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { atendimentoModel } from '@/models/atendimento'
import { normalizeProcessos } from '@/utils/normalizeProcesso'

const state = {
  loading: false,
  loadingStore: false,
  atendimento: [],
  atendimentosPorProcesso: [],
  processoAtendimento: [],
  atendimentoSelecionado: undefined,
  erros: '',
  pendencia_processo: [],
  //filter: {},
}

const getters = {
  GET_PROCESSOSATENDIMENTO: (state) => state.processoAtendimento,
  GET_ATENDIMENTOSPORPROCESSO: (state) => state.atendimentosPorProcesso,
  GET_ATENDIMENTOS: (state) => state.atendimento,
  GET_ERROS: state => state.erros,
}

const mutations = {

  PENDENCIA_PROCESSO: (state, { pendencia_processo }) => {
    state.pendencia_processo = JSON.parse(JSON.stringify(pendencia_processo))
  },

  SET_PROCESSOSATENDIMENTO: (state, { processos }) => {
   // console.log("SET_PROCESSOSATENDIMENTO",processos)
    state.processoAtendimento = normalizeProcessos(JSON.parse(JSON.stringify(processos)))
   // console.log("state",state.processoAtendimento)
  },

  SET_ATENDIMENTOSPORPROCESSO: (state, { atendimentos }) => {
    state.atendimentosPorProcesso = atendimentos
  },

  SET_ATENDIMENTOS: (state, { atendimentos }) => {
    state.atendimento = atendimentos
  },

  ATENDIMENTO_SELECTED: (state, { atendimento }) => {
    state.atendimentoSelecionado = Object.assign({}, atendimento)
  },

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  SET_ERROS: (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS: (state) => {
    state.erros = ''
  },

  // SET_FILTER: (state, filter) => {
  //   state.filter = filter
  // },

  RESET_SELECTED: state => state.atendimentoSelecionado = undefined,

}

const actions = {

  GET_PROCESSOSATENDIMENTO: async ({ commit }, filter) => {
    commit('ERASE_ERROS')
    commit('SET_PROCESSOSATENDIMENTO', { processos: [] })
    await AtendimentoService.postProcessosEmAtendimento(filter)
      .then(response => {
        if (response.data.status) {
         // console.log(response.data)
          let processos = response.data.processos ? response.data.processos : []
          commit('SET_PROCESSOSATENDIMENTO', { processos : processos ? processos : [] })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        commit('SET_ERROS', { erros: 'Erro ao acessar api (GET_PROCESSOSATENDIMENTO)' })
        reject(error)
      })
  },

  GET_PENDENCIAPROCESSO: async ({ commit }, filter) => {
    commit('ERASE_ERROS')
    commit('PENDENCIA_PROCESSO', { pendencia_processo: [] })
    if (!filter.idProcesso || !(filter.idProcesso > 0)) filter.idProcesso = null
    if (!filter.idCategoria || !(filter.idCategoria > 0)) filter.idCategoria = null
    await AtendimentoService.getPendenciaProcesso(filter)
      .then(response => {
        if (response.data.status) {
          commit('PENDENCIA_PROCESSO', { pendencia_processo: response.data.pendencia_processo })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        commit('SET_ERROS', { erros: 'Erro ao acessar api (GET_PENDENCIAPROCESSO)' })
        reject(error)
      })

  },

  GET_ATENDIMENTOSPORPROCESSO: async ({ commit }, id) => {
    commit('SET_ATENDIMENTOSPORPROCESSO', { atendimentos: [] })
    commit('ERASE_ERROS')
    await AtendimentoService.getAtendimentosPorProcesso(id)
      .then(response => {
        if (response.data.status) {
          commit('SET_ATENDIMENTOSPORPROCESSO', { atendimentos: response.data.atendimentos })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        commit('SET_ERROS', { erros: 'Erro ao acessar api (GET_ATENDIMENTOSPORPROCESSO(?))' })
        reject(error)
      })
  },

  GET_ATENDIMENTOS: async ({ commit }, id) => {
    commit('SET_ATENDIMENTOS', { atendimentos: [] })
    commit('ERASE_ERROS')
    await AtendimentoService.getAtendimentos(id)
      .then(response => {
        if (response.data.status) {
          commit('SET_ATENDIMENTOS', { atendimentos: response.data.atendimentos })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        commit('SET_ERROS', { erros: 'Erro ao acessar api (GET_ATENDIMENTOS)' })
        reject(error)
      })
  },

  GET_ATENDIMENTO: async ({ commit }, id) => {
    commit('ERASE_ERROS')
    await AtendimentoService.getAtendimento(id)
      .then(response => {
        if (response.data.status) {
          commit('ATENDIMENTO_SELECTED', { atendimento: response.data.atendimento })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        commit('SET_ERROS', { erros: 'Erro ao acessar api (GET_ATENDIMENTO(?))' })
        reject(error)
      })

  },

  STORE_ATENDIMENTO: async ({ commit, dispatch }, atendimento) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      var response = await AtendimentoService.postAtendimento(atendimento)
      if (response.data.status) {
        commit('ATENDIMENTO_SELECTED', { atendimento: response.data.atendimento })
      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      commit('SET_ERROS', { erros: 'Erro ao acessar api (STORE_ATENDIMENTO)' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_ATENDIMENTO: async ({ commit, dispatch }, atendimento) => {
    commit('ERASE_ERROS')
    let id = atendimento.processo_id ? atendimento.processo_id : null
    try {
      var response = await AtendimentoService.deleteAtendimento(atendimento.id)

      if (response.data.status) {
        await dispatch('GET_ATENDIMENTOSPORPROCESSO', id)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  ATENDIMENTO_SELECTED: async ({ dispatch, commit }, id) => {
    if (id > 0) {
      await dispatch('GET_ATENDIMENTO', id)
    } else {
      var obj = new atendimentoModel.atendimento()
      await commit('ATENDIMENTO_SELECTED', { atendimento: obj })
    }
  },

  RESET_SELECTED: ({ commit }) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Atendimento/_store/index.js